// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import { computed } from 'vue'
import { useStore } from '@nanostores/vue'
import { isLogin } from '@/store/userStore'
import { getProductSharingUrl } from '@/legacy/ts/productSharing'
import BaseButton from '@/components/ui/button/BaseButton.vue'
import {
	type HeroSectionData,
	type HeroButtonType,
} from '@/components/HeroSection.vue'
import ReverseSlider from '@/components/reverse-slider/ReverseSlider.vue'
import ImageSlider from '@/components/reverse-slider/ImageSlider.vue'
import BuyaholicReverseSlider from '@/pages/buyaholic/components/_BuyaholicReverseSlider.vue'
import useImageSlider from '@/lib/useImageSlider'
import hybridPage from '@/lib/hybridPage'
import { type RegistrationCardData } from '@/components/RegistrationCard.vue'
import { getCreditText, setCurrentGaPageName } from '@/lib/utils'
import {
	GaGeneralEvent,
	createGAEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'

hybridPage()

createApp({
	name: 'Buyaholic',
	components: {
		BaseButton,
		ReverseSlider,
		ImageSlider,
		BuyaholicReverseSlider,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.CommunityFeature)
		createGAEvent(GaGeneralEvent.PageLoad, {
			page_name: GaGeneralPageName.CommunityFeature,
		})

		const { sliderRef, translateX } = useImageSlider()
		const { reverseSlider } = window.pageContent
		const isLoginGlobal = useStore(isLogin)
		const heroSectionData: HeroSectionData = window.pageContent.heroContent
		const currentHeroSectionData = computed(() => {
			return isLoginGlobal.value
				? heroSectionData.afterLogin
				: heroSectionData.beforeLogin
		})

		function handleHeroSectionButtonClick(buttonType: HeroButtonType) {
			if (buttonType === 'primary') {
				if (currentHeroSectionData.value.primaryBtnLink) {
					window.location.href = currentHeroSectionData.value.primaryBtnLink
					return
				}
				window.location.href = getProductSharingUrl('recommended')
			}
		}

		// ---------------------
		// Registration Card Section Start
		// ---------------------
		const registrationCardData: RegistrationCardData =
			window.pageContent.registrationContent

		const currentRegistrationCardContent = computed(() => {
			return isLoginGlobal.value
				? registrationCardData.afterLogin
				: registrationCardData.beforeLogin
		})

		const currentRegistrationCardTitle1 = computed(() => {
			return getCreditText(currentRegistrationCardContent.value.title1)
		})

		const currentRegistrationCardTitle2 = computed(() => {
			return getCreditText(currentRegistrationCardContent.value.title2)
		})

		const WELCOME_CREDIT = window.BUYANDSHIP?.settings?.member_welcome_credits

		const currentRegistrationCardDesc = computed(() => {
			return getCreditText(currentRegistrationCardContent.value.description)
		})

		const bgRegistrationCardClass = computed(() => {
			return currentRegistrationCardContent.value.class
		})

		const openReferral = (link?: string) => {
			if (link) {
				window.location.href = link
				return
			}
			window.location.href = getProductSharingUrl('referral')
		}

		const openRegister = () => {
			window.BsHeaderVm.showSignupPanel()
		}

		const handleRegistrationCardClick = (link?: string) => {
			if (isLoginGlobal.value) {
				openReferral(link)
			} else {
				openRegister()
			}
		}
		// ---------------------
		// Registration Card Section End
		// ---------------------

		const contentOtherService = window.pageContent.otherServiceContent

		return {
			WELCOME_CREDIT,
			// ================== Login Hero ==================
			isLoginGlobal,
			currentHeroSectionData,
			handleHeroSectionButtonClick,
			// ================== Reverse Slider ==================
			reverseSlider,
			sliderRef,
			translateX,
			// ================== Registration Card ==================
			currentRegistrationCardContent,
			currentRegistrationCardTitle1,
			currentRegistrationCardTitle2,
			currentRegistrationCardDesc,
			bgRegistrationCardClass,
			handleRegistrationCardClick,
			// ================== Other Service ==================
			contentOtherService,
		}
	},
}).mount('#bsMain')
